import React, { useEffect } from "react";
import "./App.css";
import Aos from "aos";
import "aos/dist/aos.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { StyleSheetManager } from "styled-components";
import CreateAccount from "pages/auth/create-account";
import Login from "pages/auth/login";
import DashboardOverview from "pages/dashboard/overview";
import RatedTube from "pages/dashboard/overview/pages/rated-tube";
import DashboardOverviewDiscography from "pages/dashboard/overview/pages/discography-page";

import ForgotPassword from "pages/auth/forgot-password";
import ResetPassword from "pages/auth/forgot-password/pages/reset-password";
import UploadMusic from "pages/dashboard/overview/pages/upload-music";
import UploadVideo from "pages/dashboard/overview/pages/upload-video";
import TrackPage from "pages/dashboard/overview/pages/track";
import MusicVideo from "pages/dashboard/overview/pages/music-video";
import "react-toastify/dist/ReactToastify.css";
import { StyledToastContainer } from "components/toast/styledToastContainer";
import TrackShare from "pages/shared-link/track-share";
import VideoShare from "pages/shared-link/video-share";
import RatedFans from "pages/dashboard/overview/pages/rated-fans";
import TrackLyrics from "pages/dashboard/overview/pages/track-lyrics";
import CustomizeLink from "pages/dashboard/overview/pages/rated-fans/pages/customizeLink";
import Home from "pages/landing-page/home";
import PricingSummary from "pages/landing-page/pricing/pages/summary";
import Pricing from "pages/landing-page/pricing";
import AboutUs from "pages/landing-page/about-us";
import Blog from "pages/landing-page/blog";
import DashboardArtists from "pages/dashboard/artists";
import DashboardUpgrade from "pages/dashboard/upgrade-page";
import DashboardSettings from "pages/dashboard/settings";
import SettingProfile from "pages/dashboard/settings/pages/Profile";
import SettingsSubscriptions from "pages/dashboard/settings/pages/manage-subscriptions";
import { Provider } from "react-redux";
import { persistor, store } from "./redux/app/store";
import { PersistGate } from "redux-persist/integration/react";
import RatedAfrikaPlaylist from "pages/dashboard/overview/pages/rated-afrika-playlist";
import PromoCards from "pages/dashboard/overview/pages/promo-cards";
import CreatePromoCard from "pages/dashboard/overview/pages/promo-cards/pages/create-promo-card";
import SpotifyCanvasGenerator from "pages/dashboard/overview/pages/spotify-canvas-generator";
import PitchEasy from "pages/dashboard/overview/pages/pitch-easy";
import DashboardInsights from "pages/dashboard/insights";
import EditMetadata from "pages/dashboard/overview/pages/edit-metadata";
import DashboardSplits from "pages/dashboard/splits";
import DashboardPromotion from "pages/dashboard/promotion";
import DashboardPromoType from "pages/dashboard/promotion/pages/promoType";

const App = () => {
  useEffect(() => {
    Aos.init({
      offset: 200,
      duration: 500,
      once: true,
      easing: "ease-out"
    });
  }, []);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <StyleSheetManager shouldForwardProp={() => true}>
          <Router>
            <Routes>
              {/* landing page */}
              <Route path="/" element={<Home />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/blog" element={<Blog />} />

              {/* pricing*/}
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/pricing/summary" element={<PricingSummary />} />

              {/* auth */}
              <Route path="/create-account" element={<CreateAccount />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/forgot-password/reset"
                element={<ResetPassword />}
              />

              {/* dashboard */}
              {/* overview */}
              <Route path="/overview" element={<DashboardOverview />} />
              <Route
                path="/overview/discography"
                element={<DashboardOverviewDiscography />}
              />
              <Route
                path="/overview/canvas-generator"
                element={<SpotifyCanvasGenerator />}
              />
              <Route path="/overview/pitch-easy" element={<PitchEasy />} />
              <Route path="/overview/rated-tube" element={<RatedTube />} />
              <Route path="/overview/rated-fans" element={<RatedFans />} />
              <Route path="/overview/promo-cards" element={<PromoCards />} />
              <Route
                path="/overview/promo-cards/create"
                element={<CreatePromoCard />}
              />
              <Route
                path="/overview/rated-fans/customize-link"
                element={<CustomizeLink />}
              />

              <Route path="/overview/upload-music" element={<UploadMusic />} />
              <Route path="/overview/upload-video" element={<UploadVideo />} />
              <Route
                path="/overview/edit-metadata/:id"
                element={<EditMetadata />}
              />
              <Route
                path="/overview/discography/track/:id"
                element={<TrackPage />}
              />
              <Route
                path="/overview/discography/track-lyrics/:id"
                element={<TrackLyrics />}
              />
              <Route
                path="/overview/discography/rated-tube/:id"
                element={<MusicVideo />}
              />
              <Route
                path="/overview/rated-afrika-playlist"
                element={<RatedAfrikaPlaylist />}
              />
              {/* insights */}
              <Route path="/insights" element={<DashboardInsights />} />
              {/*artists*/}
              <Route path="/artists" element={<DashboardArtists />} />
              {/*splits*/}
              <Route path="/splits" element={<DashboardSplits />} />
              {/*promotion*/}
              <Route path="/promotion" element={<DashboardPromotion />} />
              <Route
                path="/promotion/promo-type"
                element={<DashboardPromoType />}
              />
              {/*upgrade*/}
              <Route path="/upgrade" element={<DashboardUpgrade />} />

              {/*settings*/}
              <Route path="/settings" element={<DashboardSettings />} />
              <Route path="/settings/profile" element={<SettingProfile />} />
              <Route
                path="/settings/manage-subscription"
                element={<SettingsSubscriptions />}
              />
              {/* shared links*/}
              <Route path="/:id" element={<TrackShare />} />
              <Route path="/video-share/:id" element={<VideoShare />} />
            </Routes>
          </Router>
          <StyledToastContainer />
        </StyleSheetManager>
      </PersistGate>
    </Provider>
  );
};

export default App;
